<template>
  <div class="currentPage">
    <div class="wrap">
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.realName"
          readonly
          input-align="right"
          label="申请人："
          class="ggInput"
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.departmentName"
          readonly
          input-align="right"
          label="报销部门："
          class="ggInput"
        />
      </van-cell-group>

      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.createTime"
          class="ggInput"
          input-align="right"
          label="报销日期："
          readonly
        />
      </van-cell-group>
      <!-- <van-cell-group class="baseNone baseSalary moreText dwBox">
        <van-field
          v-model="totalAmount"
          clearable
          class="ggInput"
          input-align="right"
          readonly
          label="报销总金额（元）："
        />
      </van-cell-group> -->
      <!-- 所属项目 -->
      <van-cell-group class="itemSite baseNone beizhu">
        <van-field
          v-model="propertyData.projectName"
          
          label="所属项目："
          placeholder="请选择"
          readonly
          class="ggInput"
          input-align="right"
          type="textarea"
          rows="1"
          autosize
        />
      </van-cell-group>
      <div v-if="propertyData.projectName != ''">
        <van-cell-group class="itemSite baseNone beizhu">
          <van-field
            :value="
              incomeAndExpenses.contractAmount != null
                ? incomeAndExpenses.contractAmount
                : 0
            "
            label="合同金额："
            readonly
            class="ggInput"
            input-align="right"
          />
        </van-cell-group>
        <van-cell-group class="itemSite baseNone beizhu">
          <van-field
            v-model="incomeAndExpenses.expenses"
            label="项目支出："
            @click="
              parseFloat(incomeAndExpenses.expenses) > 0
                ? getMoneyDetail('expend')
                : ''
            "
            :is-link="parseFloat(incomeAndExpenses.expenses) > 0"
            readonly
            class="ggInput"
          />
        </van-cell-group>

        <div
          :class="[
            'projectIncome',
            incomeAndExpenses.contractAmount != null &&
            parseFloat(incomeAndExpenses.contractAmount) > 0 &&
            incomeAndExpenses.income != null &&
            parseFloat(incomeAndExpenses.income) > 0
              ? 'changeW'
              : '',
          ]"
        >
          <van-cell-group class="itemSite baseNone beizhu">
            <van-field
              v-model="incomeAndExpenses.income"
              label="项目到账："
              @click="
                parseFloat(incomeAndExpenses.income) > 0
                  ? getMoneyDetail('income')
                  : ''
              "
              readonly
              :is-link="parseFloat(incomeAndExpenses.income) > 0"
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketPercent"
              label="营销成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketingCost"
              label="营销成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="marketingCostTotal"
              label="累计营销已支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainMarketingCost"
              label="剩余营销可支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technologyPercent"
              label="技术成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technicalCost"
              label="技术成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="technicalCostTotal"
              label="累计技术已支出成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainTechnicalCost"
              label="剩余技术可支出成本元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="bidCostTotal"
              label="累计投标成本（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionPercent"
              label="招待成本限额比例（%）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionCost"
              label="招待成本限额（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="receptionCostTotal"
              label="累计已支出招待费（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
          <van-cell-group class="itemSite baseNone beizhu moreText">
            <van-field
              v-model="remainReceptionCost"
              label="剩余可支出招待费（元）："
              readonly
              class="ggInput"
              input-align="right"
            />
          </van-cell-group>
        </div>
      </div>
      <van-cell-group class="baseNone baseSalary moreText dwBox">
        <van-field
          v-model="propertyData.receiptsNumber"
          clearable
          type="digit"
          readonly
          class="ggInput"
          input-align="right"
          label="单据张数（张）："
          placeholder
        />
      </van-cell-group>
      <van-cell-group class="baseNone baseSalary">
        <van-field
          v-model="propertyData.projectOrgan"
          clearable
          readonly
          class="ggInput"
          input-align="right"
          label="项目单位："
          placeholder
        />
      </van-cell-group>
      <div class="claimDetailMain">
        <p class="fgx"></p>
        <p class="tit">报销明细</p>
        <van-cell-group class="claimDetailBox">
          <div class="claimDetailLists">
            <div
              class="claimItem"
              v-for="item in reimburseList"
              :key="item.typeCode"
            >
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.firstTypeName"
                  label="报销类别："
                  :required="editType"
                  readonly
                  type="textarea"
                  rows="1"
                  autosize
                  class="ggInput"
                  input-align="right"
                  @click="showBxTypePickerFun(1, index)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.secondTypeName"
                  label="二级类别："
                  :required="editType"
                  readonly
                  type="textarea"
                  rows="1"
                  autosize
                  class="ggInput"
                  input-align="right"
                  @click="showBxTypePickerFun(2, index)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.thirdTypeName"
                  label="三级类别："
                  :required="editType"
                  readonly
                  type="textarea"
                  rows="1"
                  autosize
                  class="ggInput"
                  input-align="right"
                  @click="showBxTypePickerFun(3, index)"
                  :is-link="editType"
                  :placeholder="editType ? '请选择' : ''"
                />
              </van-cell-group>

              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.amount"
                  clearable
                  type="number"
                  v-enterIntNumber
                  :readonly="!editType"
                  :required="editType"
                  class="ggInput"
                  input-align="right"
                  label="金额："
                  :placeholder="editType ? '请输入...  ' : ''"
                />
              </van-cell-group>
              <van-cell-group class="baseNone baseSalary beizhu">
                <van-field
                  v-model="item.instruction"
                  clearable
                  :readonly="!editType"
                  :required="editType"
                  label="报销说明："
                  class="ggInput"
                  input-align="right"
                  :placeholder="editType ? '请输入...  ' : ''"
                  type="textarea"
                  rows="1"
                  autosize
                />
              </van-cell-group>
            </div>
          </div>
        </van-cell-group>
      </div>
      <!-- 附件 -->
      <!-- <file-view
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></file-view> -->
      <!-- 微信的附件 避免和原生交互 -->
      <wx-file-view
        v-if="is_weixn"
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></wx-file-view>
      <!-- 原生附件 -->
      <file-view
        v-else
        :filesData="propertyData"
        :editType="editType"
        class="fileview"
      ></file-view>
    </div>
    <!-- 项目支出或收入明细 -->
    <van-popup
      v-model="showProjectMoneyPicker"
      round
      closeable
      close-icon="close"
      position="bottom"
      class="moneyPicker"
    >
      <ul v-if="moneydetailList.length != '0'">
        <li v-for="item in moneydetailList" :key="item.id">
          <div class="incomeInfo">
            <p>
              {{ pickerType == "income" ? "到账类型" : "支出类型" }}：{{
                item.typeName
              }}
            </p>
            <p>
              {{ pickerType == "income" ? "到账时间" : "支出时间" }}：{{
                item.createTime
              }}
            </p>
            <p>
              {{ pickerType == "income" ? "到账金额" : "支出金额" }}：{{
                item.amount
              }}元
            </p>
            <p>备注：{{ item.remarks }}</p>
          </div>
        </li>
      </ul>

      <div class="nonePage" v-if="moneydetailList.length == '0' && refreshing">
        <img :src="baseUrl + 'empty.png'" alt />
        <p>暂无数据</p>
      </div>
    </van-popup>
    <refresh-page v-if="refreshPage" />
  </div>
</template>
  <script>
/*eslint-disable*/
import newApi from "lodash";
import { mapState, mapMutations } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const fileView = () => import("@/components/common/fileView");
const wxFileView = () => import("@/components/common/wxFileView");
import { dateFormat } from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "reimbursement",
  props: {
    id: {
      //借款记录id
      type: String,
      default: "",
    },
  },
  data() {
    return {
      editType: false, //能否编辑
      refreshPage: false, // 网络请求失败时显示
      propertyData: {
        applicantIdName: "", //报销人名称
        departmentName: "", //报销部门
        createTime: "", //申请时间
        projectName: "", //所属项目名称
        projectId: "", //所属项目code
        receiptsNumber: "", //单据张数
        projectOrgan: "", //项目单位
        baseAnnexes: [], //附件
        verifyStatus: "hold",
      },
      marketPercent: "", //营销成本比例
      marketingCost: "", // 营销成本
      marketingCostTotal: "", // 累计营销成本
      remainMarketingCost: "", //剩余营销成本
      technologyPercent: "", //技术成本比例
      technicalCost: "", // 技术成本
      technicalCostTotal: "", // 累计技术成本
      remainTechnicalCost: "", //剩余技术成本
      remainReceptionCost: "", //剩余招待费用
      receptionCostTotal: "", //累计已支出招待费
      receptionCost: "", //招待成本
      receptionPercent: "", //招待成本限额比例
      bidCostTotal: "", //累计投标成本
      incomeAndExpenses: {
        income: "",
        expenses: "",
        contractAmount: "", //合同金额
      },
      reimburseList: [
        //添加报销明细数组
        {
          typeName: "", //类型名称
          type: "", //类型code
          amount: 0,
          instruction: "",
        },
      ],
      pickerType: "", //判断弹出框显示是支出还是收入
      showProjectMoneyPicker: false, //支出或收入详情弹框默认不显示
      moneydetailList: [], //支出或收入详情列表
      refreshing: false, //无数据显示
      is_weixn: is_wei(), //是否为微信
    };
  },
  async mounted() {
    if (is_wei()) {
      document.title = "报销申请";
    }
    let time = dateFormat(new Date());
    this.commonId = this.id; //申请Id
    this.$nextTick(() => {
      this.initPage();
    });
  },
  components: {
    refreshPage,
    fileView,
    wxFileView,
  },
  methods: {
    initPage() {
      let _this = this;
      _this.$api.finance.reimburse
        .detail(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );
            _this.propertyData.createTime =
              _this.propertyData.createTime.substr(0, 10);
            _this.reimburseList = _this.propertyData.detailResultList;
            _this.getIncomeAndExpenses(res.data.projectId); //获取项目的收支情况
            _this.getCostInfo(res.data.projectId);
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getIncomeAndExpenses(id) {
      let _this = this;
      _this.$api.finance.reimburse
        .incomeAndExpenses({
          projectId: id,
          dateUnitType: "all",
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data);
            _this.incomeAndExpenses = res.data;

            if (
              res.data.contractAmount != null &&
              parseFloat(res.data.contractAmount) > 0 &&
              res.data.income != null &&
              parseFloat(res.data.income) > 0
            ) {
              let percent = (
                (parseFloat(res.data.income) /
                  parseFloat(res.data.contractAmount)) *
                100
              ).toFixed(2);
              this.$set(
                _this.incomeAndExpenses,
                "income",
                res.data.income + " (" + percent + "%" + ")"
              );
            }
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    //项目id获取成本信息I
    getCostInfo(id) {
      let _this = this;
      _this.$api.finance.reimburse
        .getCostInfo({
          projectId: id,
        })
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            console.log(res.data, "CostInfo");
            _this.marketPercent = res.data.marketPercent
              ? Number(res.data.marketPercent).toFixed(2)
              : ""; // 营销成本比例
            _this.marketingCost = res.data.marketingCost
              ? Number(res.data.marketingCost).toFixed(2)
              : ""; // 营销成本
            _this.marketingCostTotal = res.data.marketingCostTotal
              ? Number(res.data.marketingCostTotal).toFixed(2)
              : ""; // 累计营销成本
            _this.remainMarketingCost = res.data.remainMarketingCost
              ? Number(res.data.remainMarketingCost).toFixed(2)
              : ""; //剩余营销成本

            _this.technologyPercent = res.data.technologyPercent
              ? Number(res.data.technologyPercent).toFixed(2)
              : ""; //技术成本比例
            _this.technicalCost = res.data.technicalCost
              ? Number(res.data.technicalCost).toFixed(2)
              : ""; // 技术成本
            _this.technicalCostTotal = res.data.technicalCostTotal
              ? Number(res.data.technicalCostTotal).toFixed(2)
              : ""; // 累计技术成本
            _this.remainTechnicalCost = res.data.remainTechnicalCost
              ? Number(res.data.remainTechnicalCost).toFixed(2)
              : ""; // 剩余技术成本

            _this.receptionPercent = res.data.receptionPercent
              ? Number(res.data.receptionPercent).toFixed(2)
              : ""; //招待成本比例
            _this.receptionCost = res.data.receptionCost
              ? Number(res.data.receptionCost).toFixed(2)
              : ""; // 招待成本
            _this.receptionCostTotal = res.data.receptionCostTotal
              ? Number(res.data.receptionCostTotal).toFixed(2)
              : ""; // 累计已招待成本
            _this.remainReceptionCost = res.data.remainReceptionCost
              ? Number(res.data.remainReceptionCost).toFixed(2)
              : ""; // 剩余招待成本

            _this.bidCostTotal = res.data.bidCostTotal
              ? Number(res.data.bidCostTotal).toFixed(2)
              : ""; // 累计投标成本
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    getMoneyDetail(name) {
      //跳转项目支出,收入详情
      let _this = this;

      _this.pickerType = name;
      _this.getProjectMoneyDetail();
      _this.showProjectMoneyPicker = true;
    },
    getProjectMoneyDetail() {
      //项目支出或收入详情
      let _this = this;
      console.log(_this.propertyData, "_this.propertyData");
      _this.$api.project
        .projectMoneyDetail(_this.pickerType, 1, 200, {
          dateUnitType: "all",
          projectId: _this.propertyData.projectId,
        })
        .then((res) => {
          if (res.code == "1") {
            _this.moneydetailList = res.data.list;
          } else {
            _this.$toast(res.msg);
          }
          _this.refreshing = true;
        })
        .catch((err) => {
          _this.refreshing = true;
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },
  computed: {
    totalAmount() {
      //报销总金额
      let _this = this,
        total = 0;
      this.reimburseList.forEach(function (item) {
        total += Number(item.amount ? item.amount : 0);
      });
      return total;
    },
    ...mapState(["showLoad", "userinfo"]),
  },
};
</script>
  <style lang="less">
.currentPage {
  width: 100%;
  background-color: #f6f6f6;
  padding-bottom: 60px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 15px;
    // overflow-y: initial;
  }
  .delectBtn {
    width: 50%;
  }
  #searchHeight {
    text-align: left;
  }

  //添加明细样式
  .claimDetailMain {
    background-color: #fff;
    .fgx {
      width: 100%;
      height: 10px;
      background-color: #f6f6f6;
    }
    p.tit {
      position: relative;
      padding: 0 16px 0 25px;
      font-size: 15px;
      height: 45px;
      line-height: 45px;
      position: relative;
      color: #2581d6;
      font-weight: 700;
      border-bottom: 1px solid #f6f6f6;
    }
    p.tit:before {
      content: "";
      position: absolute;
      width: 5px;
      height: 20px;
      background: #2581d6;
      top: 13px;
      left: 16px;
    }
    .baseNone::after {
      content: none;
    }
    .claimDetailBox.van-cell-group.van-hairline--top-bottom::after {
      content: none;
    }
  }

  .claimDetailBox {
    width: 100%;
    padding-bottom: 10px;
    .claimDetailLists {
      width: 95%;
      margin: 0 auto;
      min-height: 140px;
    }
    .addBtn {
      margin-top: 10px;
      width: 100%;
      .addClaim {
        display: block;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
      }
    }
  }
  .claimItem {
    margin-top: 10px;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    position: relative;
    .delect {
      text-align: center;
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      background: #fff;
      border: 1px solid red;
      color: red;
      cursor: pointer;
      padding-top: 1px;
    }
  }
  .baseNone {
    .van-cell__title {
      span {
        color: #323233;
      }
    }
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.moreText {
    .van-cell {
      .van-cell__title {
        width: 200px;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  .moneyPicker {
    width: 100%;
    height: 90%;

    background-color: #f6f6f6;
    .van-popup__close-icon--top-right {
      top: 0;
      right: 5px;
      color: red;
    }
    ul {
      width: 100%;
      height: 100%;
      overflow-y: scroll;

      padding: 16px 16px 20px 16px;

      li {
        width: 100%;
        padding: 8px 8px;
        margin: 10px 0;
        background-color: #fff;
        border: 1px solid #eeeeee;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
        .incomeInfo {
          p {
            width: 100%;
            overflow: hidden;
            font-size: 15px;
            line-height: 20px;
            margin: 5px 0;
            color: #333;
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 135px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -67px;
      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
  //审批操作样式
}
</style>